import React from "react";
import { useTranslation } from "react-i18next";
import LabelForm from "pages/signup/form/labelForm";
import InputComponent from "components/input";
import { validateEmail } from "utils/helper";

const InvitationStep = ({
  register,
  errors,
  handleSubmit,
  onAccept,
  onReject,
  isLoading,
  emailParam,
}) => {
  const [t] = useTranslation();
  return (
    <div className="mt-[220px] px-[35%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)]">
      <LabelForm
        label={t("taskInvitation")}
        labelClassName="text-primary font-bold text-[28px] md-max:text-[20px] not-italic mb-[30px] text-center"
      />

      <LabelForm
        label={t("interestedTaskMsg")}
        labelClassName="text-primary font-bold text-[20px] md-max:text-[16px] not-italic"
      />

      {!emailParam && (
        <InputComponent
          label={t("emailTitle")}
          isRequired={true}
          type="email"
          name="email"
          placeholder={t("placeholder", {
            field: t("emailTitle").toLowerCase(),
          })}
          errorMessage={errors.email ? errors.email.message : ""}
          register={register}
          registerArgs={{
            required: t("errorField", { field: t("emailTitle") }),
            validate: validateEmail,
          }}
          autoFocus={true}
          labelClassName="text-primary font-semibold text-[16px] mt-[20px]"
          inputClassName={`flex h-[43px] min-w-[250px] sm-max:w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
            errors.email ? "border-red" : "border-default-color"
          } bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]`}
        />
      )}

      <div className="flex items-center justify-center gap-[10px] mt-[40px]">
        <button
          type="button"
          onClick={handleSubmit(onReject)}
          disabled={isLoading.reject}
          className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-default-color bg-white h-[46px] w-[150px]"
        >
          <div className="text-base-black font-bold text-[16px] not-italic">
            {t("reject")}
          </div>
        </button>
        <button
          type="submit"
          disabled={isLoading.accept}
          className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px] w-[150px]"
        >
          <div className="text-white font-bold text-[16px] not-italic">
            {t("accept")}
          </div>
        </button>
      </div>
    </div>
  );
};

export default InvitationStep;
